export default __webpack_public_path__ + "static/media/Eb5.60cb3368.mp3";